import { MapPin } from 'lucide-react';
import {
  filterAlphanumericWithSpaces,
  filterDigits,
} from '@/utils/function';
import { Field } from '../../ProfilePagePrimitives';
import type { ProfileOverviewForm } from '../../ProfilePage.types';

const sanitizeAddress = (value: string) =>
  filterAlphanumericWithSpaces(value);

const sanitizePincode = (value: string) =>
  filterDigits(value).slice(0, 6);

type AddressSectionProps = {
  form: ProfileOverviewForm;
  editing: boolean;
  setForm: React.Dispatch<React.SetStateAction<ProfileOverviewForm>>;
};

const ADDRESS_FIELDS: Array<{ key: keyof ProfileOverviewForm; label: string }> = [
  { key: 'locality', label: 'Locality' },
  { key: 'pincode', label: 'Pincode' },
  { key: 'country', label: 'Country' },
  { key: 'state', label: 'State' },
  { key: 'city', label: 'City' },
];

export function AddressSection({ form, editing, setForm }: AddressSectionProps) {
  return (
    <section className="rounded-2xl border border-[var(--dash-line)] bg-white p-5 text-left shadow-[0_4px_20px_-10px_rgba(16,38,73,0.08)]">
      <div className="mb-4 flex items-center gap-2">
        <MapPin className="h-4 w-4 text-[var(--dash-brand)]" />
        <h3 className="m-0 text-[15px] font-semibold text-[var(--dash-ink)]">
          Address Details
        </h3>
      </div>

      <div className="grid grid-cols-1 gap-3.5 sm:grid-cols-2">
        <div className="sm:col-span-2">
          <Field
            label="Full Address"
            value={form.fullAddress}
            editing={editing}
            onChange={(v) =>
              setForm((f) => ({ ...f, fullAddress: sanitizeAddress(v) }))
            }
          />
        </div>
        {ADDRESS_FIELDS.map(({ key, label }) => (
          <Field
            key={key}
            label={label}
            value={form[key]}
            editing={editing}
            maxLength={key === 'pincode' ? 6 : undefined}
            onChange={(v) =>
              setForm((f) => ({
                ...f,
                [key]: key === 'pincode' ? sanitizePincode(v) : sanitizeAddress(v),
              }))
            }
          />
        ))}
      </div>
    </section>
  );
}
